<template>

  <div>
     <Mainlayout></Mainlayout>
     <div class="c-app flex-row align-items-center">
    <CContainer>
      <CCol sm="12" class="mt-5">
        <br />
        <div>
          <h1 class="bg-purple">COMPULSORY TUTOR'S PLATFORM</h1>
          <h4 class="bg-orange">
            manage your online classes while growing your student base
          </h4>
        </div>
      </CCol>
      <div style="clear: both"></div>
      <br /><br /><br />
      <CCard>
        <CCol sm="12">
          <CRow>
            <CCol sm="4">
              <div class="text-center">
              <img style="max-width:100px" src="../assets/img/smallcircle.png" />
              <h5 style="color:#5b6d91">PACKAGE NAME</h5>
              </div>
              <br />
              <div class="bg-grey">Billed Anually (RM)</div>
              <div>Billed Month (RM)</div>
              <div class="bg-grey">No.Of Student</div>
              <div>No.Of Teacher</div>
              <div class="bg-grey">Including Pickiddo offer ads</div>
              <div>Customer Support <br /><br /></div>
              <div class="bg-grey">Add Payment Gateway</div>
              <div>Include Zoom Teacher License<br /></div>
              <div class="bg-grey">Cloud video storage (Gigbyte)</div>
            </CCol>
            <CCol sm="2" class="p-2">
              <div class="bg-blue">
                <div class="text-center">
                  Free <br />
                  Pickiddo Intro<br /><br />
                  <div class="bg-blue-row">0</div>
                  <div>0</div>
                  <div class="bg-blue-row">5</div>
                  <div>1</div>
                  <div class="bg-blue-row">
                    <img
                      style="max-width: 20px"
                      src="../assets/img/iconcheck.png"
                    />
                  </div>
                  <div>
                    Knowledge <br />
                    Base
                  </div>
                  <div class="bg-blue-row">
                    <img
                      style="max-width: 20px"
                      src="../assets/img/iconuncheck.png"
                    />
                  </div>
                  <div>
                    <img
                      style="max-width: 20px"
                      src="../assets/img/iconuncheck.png"
                    />
                  </div>
                  <div class="bg-blue-row">
                    <img
                      style="max-width: 20px"
                      src="../assets/img/iconuncheck.png"
                    />
                  </div>
                </div>
              </div>
            </CCol>
            <CCol sm="2" class="p-2">
              <div class="bg-oranges">
                <div class="text-center">
                  Starter Plan
                  <br />
                  Your first step with Pickiddo
                  <div class="bg-oranges-row">99</div>
                  <div>125</div>
                  <div class="bg-oranges-row">30</div>
                  <div>2</div>
                  <div class="bg-oranges-row">
                    <img
                      style="max-width: 20px"
                      src="../assets/img/iconuncheck.png"
                    />
                  </div>
                  <div>Knowledge Base/ <br />Chat</div>
                  <div class="bg-oranges-row">RM2/transaction</div>
                  <div>
                    <img
                      style="max-width: 20px"
                      src="../assets/img/iconuncheck.png"
                    />
                  </div>
                  <div class="bg-oranges-row">
                    <img
                      style="max-width: 20px"
                      src="../assets/img/iconuncheck.png"
                    />
                  </div>
                </div>
              </div>
            </CCol>
            <CCol sm="2" class="p-0 mb-0">
              <div style="padding-top:8px" class="bg-green">
                <div class="text-center">
                <span>Pro Plan </span><br />
                  Grow, Customize<br /><br />
                  <div class="bg-green-row">499</div>
                  <div>625</div>
                  <div class="bg-green-row">100</div>
                  <div>5</div>
                  <div class="bg-green-row">
                    <img
                      style="max-width: 20px"
                      src="../assets/img/iconuncheck.png"
                    />
                  </div>
                  <div>Knowledge Base/Chat/ <br />Zoom (Limited)</div>
                  <div class="bg-green-row">RM1.5/transaction</div>
                  <div>1</div>
                  <div class="bg-green-row">2</div>
                </div>
              </div>
            </CCol>
            <CCol sm="2" class="p-2">
              <div class="bg-purples">
                <div class="text-center">
                  Business Plan <br />
                  Maximum Value<br /><br />
                  <div class="bg-purples-row">0</div>
                  <div>1249</div>
                  <div class="bg-purples-row">700</div>
                  <div>20</div>
                  <div class="bg-purples-row">
                    <img
                      style="max-width: 20px"
                      src="../assets/img/iconuncheck.png"
                    />
                  </div>
                  <div>Knowledge Base/Chat/Zoom</div>
                  <div class="bg-purples-row">RM1.5/transaction</div>
                  <div>1</div>
                  <div class="bg-purples-row">2</div>
                </div>
              </div>
            </CCol>
            <CCol sm="12" style="background: #e0e8f3">
              <div class="text-center">Price per add item</div>
            </CCol>
            <CCol sm="4">
              <div class="bg-grey">Add student(10px min)Price per student</div>
              <div>Add Teacher</div>
              <div class="bg-grey">Add zoom Teacher license</div>
            </CCol>
            <CCol sm="2" class="p-2">
              <div class="bg-blue">
                <div class="text-center">
                  <div class="bg-blue-row">
                    <img
                      style="max-width: 20px"
                      src="../assets/img/iconuncheck.png"
                    />
                  </div>
                  <div>
                    <img
                      style="max-width: 20px"
                      src="../assets/img/iconuncheck.png"
                    />
                  </div>
                  <div class="bg-blue-row">
                    <img
                      style="max-width: 20px"
                      src="../assets/img/iconuncheck.png"
                    />
                  </div>
                </div>
              </div>
            </CCol>
            <CCol sm="2" class="p-2">
              <div class="bg-oranges">
                <div class="text-center">
                  <div class="bg-oranges-row">RM2</div>
                   <div>RM15</div>
                    <div class="bg-oranges-row">RM70/License</div>
                </div>
              </div>
            </CCol>
            <CCol sm="2" class="p-0">
              <div class="bg-green">
                <div style="padding-top:8px" class="text-center">
                  <div class="bg-green-row">RM1</div>
                   <div>RM10</div>
                     <div class="bg-green-row">RM70/License</div>
                </div>
              </div>
            </CCol>
            <CCol sm="2" class="p-2">
              <div class="bg-purples">
                <div class="text-center">
                  <div class="bg-purples-row">RM1</div>
                   <div>RM10</div>
                     <div class="bg-purples-row">RM70/License</div>
                </div>
              </div>
            </CCol>
          </CRow>
        </CCol>
      </CCard>
    </CContainer>


     </div>
  </div>
</template>


<script>
import Vue from "vue";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
import _ from "lodash";

import backgroundUrl from "../assets/img/bgSkill.png";
import backgroundBanner from "../assets/img/edu.jpg";
import backgroundBannerUrl from "../assets/img/bg4.png";
import backgroundBannerReg from "../assets/img/bgReg.jpg";
import backgroundUrlNews from "../assets/img/update.jpg";
import backgroundUrlContact from "../assets/img/bgcontact.png";
import backgroundLearn from "../assets/img/bgLearn.png";

import Mainlayout from "../containers/AllHeaderLanding.vue";

import AOS from "aos";
import "aos/dist/aos.css";

export default {
  name: "ProClass",
  components: {
    Mainlayout
  },
  data() {
    return {
      backgroundUrl,
      backgroundBanner,
      backgroundBannerUrl,
      backgroundBannerReg,
      backgroundUrlNews,
      backgroundUrlContact,
      backgroundLearn,

      // Name,
      // PhoneNumber,
      // Email,
      // Message,
    };
  },
  created() {
    AOS.init();
 
  },
  mounted() {
   this.$forceUpdate();
  },
  methods: {
    InsertPartner() {
      const formData = new FormData();

      formData.append("Name", this.Name);
      formData.append("Email", this.Email);
      formData.append("PhoneNumber", this.PhoneNumber);
      formData.append("Message", this.Message);

      return this.$API
        .post(this.$RegisterPartner, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.$dialog
              .alert("You have successfully save data")
              .then(function (dialog) {
                console.log("Closed");
              });
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
     
  },
};
</script>

<style>
body {
  background: #fff;
}
.carousel-indicators li {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #000015;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  -webkit-transition: opacity 0.6s ease;
  transition: opacity 0.6s ease;
}

.custom-font {
  font-family: "Rubik", sans-serif;
}

.change_color {
  background-color: red;
}

* {
  padding: 0;
  margin: 0;
}

body {
  height: 100vh;
}
body nav {
  position: fixed;
  width: 100%;
  height: 70px;
  background-color: transparent;
  display: flex;
  align-items: center;
  transition: all 0.2s ease-in-out;
}
body nav.onScroll {
  box-shadow: 0 0 10px #aaa;
  background-color: rgb(255, 255, 255);
}
body nav.onScroll ul li {
  color: #10b761;
}
body nav ul {
  margin-left: 3em;
  width: 25%;
  display: flex;
  justify-content: space-between;
}
body nav ul li {
  cursor: pointer;
  font-weight: 600;
  list-style-type: none;
  color: white;
}

.c-header {
  background: rgb(23, 77, 124);
  background: linear-gradient(92deg, #174d7c, #1b7682);
  border-bottom: 0.01px solid #1a6783;
  border-bottom: 1px solid #636f83;
  /* color: #fff; */
}

@import url("https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500&display=swap");
</style>

